// SP-3 — shared option rules for the three TPS reassign/switch pickers
// (TpsAssignmentCard reassign modal, TpsLoansDrawer orderly reassign,
// EmergencyTpsSwitchModal target select). Keeps the label + disabled rules
// in lockstep: the default placeholder is always selectable and reads as
// unassigning; a real TPS that hasn't finished onboarding is disabled and
// annotated "Not ready".

import { NO_SERVICER_ASSIGNED, tpsDisplayName } from "./tpsDisplay";
import type { TpsDto, TpsReadinessSummaryDto } from "@/types/tps";

export function buildReadinessMap(
  rows: TpsReadinessSummaryDto[] | undefined,
): Map<string, TpsReadinessSummaryDto> {
  return new Map((rows ?? []).map((r) => [r.tpsId, r]));
}

export function tpsOptionLabel(
  tps: TpsDto,
  entityName: string | null | undefined,
  readiness: Map<string, TpsReadinessSummaryDto>,
): string {
  if (tps.isDefault) return `${NO_SERVICER_ASSIGNED} (unassign)`;
  const label = tpsDisplayName(tps, entityName);
  const r = readiness.get(tps.id);
  return r && !r.isReady ? `${label} — Not ready` : label;
}

/** A real TPS that hasn't finished onboarding can't be chosen up front; the
 * default placeholder ("unassign") is always available. */
export function tpsOptionDisabled(
  tps: TpsDto,
  readiness: Map<string, TpsReadinessSummaryDto>,
): boolean {
  return !tps.isDefault && readiness.get(tps.id)?.isReady === false;
}
